import { useEffect } from "react";

function useLockBodyScroll(isLocked) {
  useEffect(() => {
    // ✅ Prevent running on the server
    if (typeof document === "undefined" || typeof window === "undefined")
      return;

    if (!isLocked) return;

    // Save the original overflow style to restore it later
    const originalStyle = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    // Cleanup function to restore the original style
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isLocked]);
}

export default useLockBodyScroll;
